import {
  AttrContainer,
  Heading3Container,
  Heading4Container,
  HeadingContainer,
  ListContainer,
  QuoteContainer,
} from '@/components/page/case-study/Body/Body.styles';

export const initializeLists = () => {
  return {
    UlList: [],
    ulFirstId: [],
    OlList: [],
    olFirstId: [],
    splitUlList: [],
    splitOlList: [],
  };
};

export const processPostBodyList = (
  postBody,
  UlList,
  ulFirstId,
  OlList,
  olFirstId,
) => {
  processListItem(postBody, UlList, ulFirstId, 'bullet');
  processListItem(postBody, OlList, olFirstId, 'number');
};

export const splitLists = (firstIdList, mainList, splitList) => {
  firstIdList.forEach((item) => {
    if (firstIdList.indexOf(item) === firstIdList.length - 1) {
      splitList.push(
        mainList.slice(mainList.indexOf(mainList[item]), mainList.length),
      );
    } else {
      const nextItem = firstIdList[firstIdList.indexOf(item) + 1];
      splitList.push(
        mainList.slice(
          mainList.indexOf(mainList[item]),
          mainList.indexOf(mainList[nextItem]),
        ),
      );
    }
  });
};

export const findMatchingListBlock = (block, OlList, UlList) => {
  const ulBlock = findListBlock(block, UlList);
  const olBlock = findListBlock(block, OlList);

  return olBlock || ulBlock || block;
};

const findListBlock = (block, list) => {
  if (list.length > 0) {
    if (Array.isArray(list[0])) {
      for (const sublist of list) {
        if (block._key === sublist[0]._key) {
          return sublist;
        }
      }
    } else if (block._key === list[0]._key) {
      return list;
    }
  }
  return null;
};

export const processListItem = (postBody, list, firstIdList, listItemType) => {
  if (postBody.listItem === listItemType) {
    list.push(postBody);
    const index = Object.keys(postBody).indexOf(postBody);
    if (index !== 0 && postBody[index - 1]?.listItem !== listItemType) {
      firstIdList.push(list.indexOf(postBody));
    }
  }
};

export const getElementComponent = (style, isStrong) => {
  switch (style) {
    case 'h2':
      return { component: HeadingContainer };
    case 'h3':
      return { component: Heading3Container };
    case 'h4':
      return { component: Heading4Container };
    case 'blockquote':
      return {
        component: QuoteContainer,
        props: { weight: (isStrong && 500) || 400 },
      };
    case 'quoteatt':
      return { component: AttrContainer };
    default:
      return null;
  }
};

export const getListComponent = (isList, list, id) => {
  if (isList && (list === 'bullet' || list === 'number')) {
    return {
      component: ListContainer,
      props: { id },
    };
  }
  return null;
};
